import { assignedSeats, availableTGs, calculateSeatAssignments } from '@/seats/assignments';
export default class SeatSelection {
    required;
    available;
    #value = {};
    constructor(required) {
        this.required = required;
        this.#update();
    }
    /**
     * @deprecated Use Seat.select().
     */
    add(seat) {
        if (seat.state !== 'available') {
            throw new Error(`Only available seats may be selected. Seat ${seat.name} is ${seat.state}`);
        }
        this.#value[seat.name] = seat;
        return this.#update();
    }
    /**
     * @deprecated Use Seat.deselect().
     */
    remove(seat) {
        if (seat.state !== 'selected') {
            throw new Error(`Only selected seats may be deselected. Seat ${seat.name} is ${seat.state}`);
        }
        delete this.#value[seat.name];
        return this.#update();
    }
    #update() {
        // Calculate all the different ways selected seats can be assigned.
        const sets = calculateSeatAssignments(this.#value, this.required);
        // TGs that may still have seats assigned to them.
        this.available = availableTGs(sets, this.required);
        // Debug
        // console.log('Selected', Object.keys(this.#value))
        // console.log('Assignments', _serializeSeatAssignments(sets))
        // console.log('Available TGs', this.available)
        if (this.available.size === 0) {
            // Any seat assignment set will do.
            return assignedSeats(sets[0], this.required);
        }
    }
}
